const featured = {
  date: '12 juin 2026',
  tag: 'Téléphonie IP',
  title: 'Déploiement complet de la téléphonie IP chez une nouvelle clinique partenaire',
  text:
    "Cette semaine, notre équipe a terminé la migration vers la téléphonie IP d'une clinique de la région : transfert des numéros existants, configuration des postes dans chaque salle de soins et formation du personnel — réalisé en moins d'une semaine, sans interruption de service pour les patients.",
};

const news = [
  {
    date: '2 juin 2026',
    tag: 'Sécurité',
    title: 'Campagne de sensibilisation à l\'hameçonnage pour nos clients',
    text: "Nous avons lancé une série de courtes formations pour aider les équipes de nos clients à reconnaître les courriels frauduleux — une mesure simple qui réduit considérablement les risques.",
  },
  {
    date: '20 mai 2026',
    tag: 'Partenariat',
    title: 'Nouveau partenariat avec Ubiquiti pour la gestion de réseaux',
    text: 'Ce partenariat nous permet de déployer des réseaux Wi-Fi et filaires encore plus performants et faciles à superviser à distance pour nos clients en clinique et en bureau.',
  },
  {
    date: '8 mai 2026',
    tag: 'Téléphonie IP',
    title: 'La téléphonie IP maintenant offerte en mode multi-sites',
    text: 'Les entreprises avec plusieurs emplacements peuvent désormais centraliser leur standard téléphonique : un seul système, des numéros locaux pour chaque succursale.',
  },
  {
    date: '22 avril 2026',
    tag: 'Équipe',
    title: 'CPUc agrandit son équipe de support technique',
    text: "Pour répondre à la demande croissante, un nouveau technicien s'est joint à notre équipe de support — encore plus de disponibilité pour vos demandes urgentes.",
  },
  {
    date: '15 avril 2026',
    tag: 'Cloud',
    title: 'Migration réussie vers Microsoft 365 pour une résidence pour aînés',
    text: 'Boîtes courriel, partage de documents et visioconférence centralisés sur une seule plateforme, avec formation du personnel administratif.',
  },
  {
    date: '2 avril 2026',
    tag: 'Communauté',
    title: 'CPUc présent au déjeuner-conférence de la chambre de commerce',
    text: "Notre équipe a échangé avec des entrepreneurs locaux sur les bonnes pratiques en cybersécurité et sur les avantages de la téléphonie IP pour les petites équipes.",
  },
];

export default function Actualites() {
  return (
    <>
      <section className="section pb-0">
        <div className="container text-center" data-aos="fade-up">
          <span className="eyebrow">Actualités</span>
          <h1 className="fw-900 mt-3 display-5">Ce qui se passe chez CPUc</h1>
          <p className="lead text-secondary mx-auto" style={{ maxWidth: '680px' }}>
            Nouveaux projets, partenariats et activités — un aperçu de notre quotidien
            auprès de nos clients.
          </p>
        </div>
      </section>

      {/* À LA UNE */}
      <section className="section pt-4">
        <div className="container">
          <div className="news-card p-4 p-md-5" data-aos="fade-up">
            <div className="row align-items-center gy-4">
              <div className="col-lg-8">
                <span className="news-date">{featured.date}</span>
                <span className="news-tag ms-2">{featured.tag}</span>
                <h2 className="fw-900 mt-3">{featured.title}</h2>
                <p className="text-secondary mb-0">{featured.text}</p>
              </div>
              <div className="col-lg-4 text-center">
                <div className="d-inline-flex align-items-center justify-content-center rounded-circle"
                     style={{ width: '8rem', height: '8rem', background: 'var(--cpuc-red-soft)' }}>
                  <i className="bi bi-telephone-fill text-brand" style={{ fontSize: '3rem' }}></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* GRILLE D'ACTUALITÉS */}
      <section className="section pt-0">
        <div className="container">
          <div className="row g-4">
            {news.map((n, i) => (
              <div className="col-md-6 col-lg-4" key={n.title} data-aos="fade-up" data-aos-delay={(i % 3) * 100}>
                <div className="news-card p-4 h-100">
                  <span className="news-date">{n.date}</span>
                  <span className="news-tag ms-2">{n.tag}</span>
                  <h3 className="h6 fw-bold mt-3">{n.title}</h3>
                  <p className="text-secondary small mb-0">{n.text}</p>
                </div>
              </div>
            ))}
          </div>

          <p className="text-secondary small mt-4 mb-0">
            * Actualités présentées à titre d'exemple — remplacez ce contenu par vos propres
            annonces, projets terminés et événements.
          </p>
        </div>
      </section>
    </>
  );
}
